import type { FC, ReactNode } from 'react'

/**
 * A north arrow and a 0 to 10 m scale bar at 1 : 200, drawn in fine lines.
 */
export const NorthScale: FC = (): ReactNode => {
    const blocks = [0, 1, 2, 3, 4]

    return (
        <div className='flex items-end gap-6' aria-hidden='true'>
            <svg viewBox='0 0 40 52' className='h-[52px] w-10 flex-none'>
                <circle cx={20} cy={32} r={15} fill='none' stroke='#3A3630' strokeWidth={1} />
                <line x1={20} y1={13} x2={20} y2={51} stroke='#3A3630' strokeWidth={1} />
                <line x1={1} y1={32} x2={39} y2={32} stroke='#3A3630' strokeWidth={1} />
                <path d='M20 19 L26 40 L20 35 Z' fill='#ECE6D8' />
                <path d='M20 19 L14 40 L20 35 Z' fill='none' stroke='#ECE6D8' strokeWidth={1} strokeLinejoin='miter' />
                <text x={20} y={9} textAnchor='middle' fontFamily='var(--font-app-mono, ui-monospace, monospace)' fontSize={9} letterSpacing={1} fill='#ECE6D8'>
                    N
                </text>
            </svg>

            <div className='min-w-0 flex-1'>
                <svg viewBox='0 0 150 24' className='block h-6 w-full max-w-[180px]' preserveAspectRatio='xMinYMid meet'>
                    {blocks.map(block => (
                        <rect
                            key={block}
                            x={0.5 + block * 28}
                            y={6.5}
                            width={28}
                            height={5}
                            fill={block % 2 === 0 ? '#ECE6D8' : 'none'}
                            stroke='#ECE6D8'
                            strokeWidth={1}
                        />
                    ))}

                    {[0, 70, 140].map((x, index) => (
                        <text key={x} x={x + 0.5} y={22} textAnchor={index === 0 ? 'start' : index === 2 ? 'end' : 'middle'} fontFamily='var(--font-app-mono, ui-monospace, monospace)' fontSize={8} letterSpacing={0.6} fill='#8A8478'>
                            {index === 0 ? '0' : index === 1 ? '5' : '10 M'}
                        </text>
                    ))}
                </svg>

                <p className='hud mt-1 text-mute'>
                    1 : 200
                </p>
            </div>
        </div>
    )
}
